module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.3877/img/storefront-header-blobs.svg"